// @ts-ignore
if (!Promise?.withResolvers) {
  // @ts-ignore
  Promise.withResolvers = function <T>() {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
  };
}

if (!URL.parse) {
  URL.parse = function (url: string, base?: string): URL | null {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

if (Object.prototype.hasOwnProperty.call(Array.prototype, 'flatten')) {
  Object.defineProperty(Array.prototype, 'flatten', {
    enumerable: false,
    writable: true,
    configurable: true,
    // @ts-ignore
    value: Array.prototype.flatten,
  });
}
